import gql from "graphql-tag"

const SET_EXHIBIT_ORDER = gql`
  mutation SetExhibitOrder($caseFolderId: ID!, $orderId: ID!) {
    setExhibitOrder(caseFolderId: $caseFolderId, orderId: $orderId)
  }
`
export default SET_EXHIBIT_ORDER
